import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const currentYear = new Date().getFullYear();
  return <footer className="bg-warm-dark text-warm-gray py-12 border-t border-white/10" data-id="element-17">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-18">
        <div className="mb-8" data-id="element-19">
          <p className="font-serif text-xl text-cream mb-2" data-id="element-20">Sistema 3 Anclas</p>
          <p className="text-sm opacity-60 max-w-md mx-auto" data-id="element-21">
            Transformando vidas a través de una alimentación consciente y
            sostenible.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm font-medium" data-id="element-22">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-terracotta transition-colors focus:outline-none focus:underline decoration-terracotta underline-offset-4" data-id="element-23">
            Política de Privacidad
          </button>
          <span className="text-white/20 hidden sm:inline" data-id="element-24">•</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-terracotta transition-colors focus:outline-none focus:underline decoration-terracotta underline-offset-4" data-id="element-25">
            Términos y Condiciones
          </button>
        </div>

        <div className="pt-8 border-t border-white/5" data-id="element-26">
          <p className="text-xs opacity-50 mb-2" data-id="element-27">
            &copy; {currentYear} Sistema 3 Anclas. Todos los derechos
            reservados.
          </p>
          <p className="text-xs opacity-40 max-w-2xl mx-auto" data-id="element-28">
            Este producto no sustituye el consejo médico profesional. Consulta a
            tu médico antes de comenzar cualquier programa de alimentación o
            ejercicio. Los resultados pueden variar de una persona a otra.
          </p>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-29">
        <div className="space-y-4 text-sm sm:text-base" data-id="element-30">
          <p data-id="element-31">Última actualización: {new Date().toLocaleDateString()}</p>

          <h3 data-id="element-32">1. Recopilación de Información</h3>
          <p data-id="element-33">
            Recopilamos información que usted nos proporciona directamente
            cuando se registra para usar nuestro servicio, realiza una compra o
            se comunica con nosotros. Esta información puede incluir su nombre,
            dirección de correo electrónico e información de pago.
          </p>

          <h3 data-id="element-34">2. Uso de la Información</h3>
          <p data-id="element-35">
            Utilizamos la información recopilada para proporcionar, mantener y
            mejorar nuestros servicios, procesar transacciones, enviar
            confirmaciones y comunicarnos con usted sobre productos, servicios,
            ofertas y promociones.
          </p>

          <h3 data-id="element-36">3. Protección de Datos</h3>
          <p data-id="element-37">
            Implementamos medidas de seguridad diseñadas para proteger su
            información personal contra acceso no autorizado y uso indebido. Sin
            embargo, ninguna transmisión de datos por Internet es 100% segura.
          </p>

          <h3 data-id="element-38">4. Cookies</h3>
          <p data-id="element-39">
            Utilizamos cookies y tecnologías similares para mejorar su
            experiencia, analizar tendencias y administrar el sitio web. Puede
            controlar el uso de cookies a través de la configuración de su
            navegador.
          </p>

          <h3 data-id="element-40">5. Terceros</h3>
          <p data-id="element-41">
            No vendemos ni alquilamos su información personal a terceros.
            Podemos compartir información con proveedores de servicios que nos
            ayudan a operar nuestro negocio (procesamiento de pagos, envío de
            correos, etc.).
          </p>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-42">
        <div className="space-y-4 text-sm sm:text-base" data-id="element-43">
          <p data-id="element-44">Última actualización: {new Date().toLocaleDateString()}</p>

          <h3 data-id="element-45">1. Aceptación de los Términos</h3>
          <p data-id="element-46">
            Al acceder y utilizar el Sistema 3 Anclas, usted acepta estar
            legalmente vinculado por estos términos y condiciones. Si no está de
            acuerdo con alguno de estos términos, no debe utilizar nuestros
            servicios.
          </p>

          <h3 data-id="element-47">2. Descargo de Responsabilidad Médica</h3>
          <p className="font-medium bg-terracotta/10 p-3 rounded-lg border border-terracotta/20" data-id="element-48">
            El contenido proporcionado en este sitio web y en nuestros programas
            es solo para fines informativos y educativos. No pretende sustituir
            el consejo médico profesional, diagnóstico o tratamiento. Siempre
            busque el consejo de su médico u otro proveedor de salud calificado.
          </p>

          <h3 data-id="element-49">3. Propiedad Intelectual</h3>
          <p data-id="element-50">
            Todo el contenido, incluyendo textos, gráficos, logos, imágenes y
            software, es propiedad de Sistema 3 Anclas y está protegido por
            leyes de derechos de autor. Se le concede una licencia limitada para
            acceder y usar el material para su uso personal y no comercial.
          </p>

          <h3 data-id="element-51">4. Política de Reembolso</h3>
          <p data-id="element-52">
            Ofrecemos una garantía de satisfacción. Si no está satisfecho con el
            programa, puede solicitar un reembolso dentro del período
            especificado en la oferta de compra, sujeto a los términos de dicha
            garantía.
          </p>

          <h3 data-id="element-53">5. Modificaciones</h3>
          <p data-id="element-54">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación en el sitio web. Su uso continuado del servicio
            constituye la aceptación de dichos cambios.
          </p>
        </div>
      </Modal>
    </footer>;
}